import * as React from 'react';
import logo from '../../images/logo.svg'

export class Loader extends React.PureComponent<{}> {

    public render() {
        return (
            <div className='loader'>
                <img src={logo} />
                <div ><div></div><div></div></div>
            </div>
        );
    }
}

export class Spinner extends React.PureComponent<{ color?: string, secondColor?: string }> {

    public render() {
        return (
            <div className={`spinner ${this.props.color}`}>
                <span style={{ borderTop: `4px solid ${this.props.secondColor}` }}></span>
            </div>
        );
    }
}